import {InjectionToken} from "@angular/core";
import {IIntDefaultPaginatorTestMarker} from "../types";



export const INT_DEFAULT_PAGINATOR_TEST_MARKERS_TOKEN = new InjectionToken<IIntDefaultPaginatorTestMarker>('INT_DEFAULT_PAGINATOR_TEST_MARKERS_TOKEN', {
  factory(): IIntDefaultPaginatorTestMarker {
    return {
      perPageActionMarker: null,
      perPageListItemMarker: null,
      pageSelectorAction: null,
      pageSelectorListItem: null,
      prevPageAction: null,
      nextPageAction: null,
    }
  },
  providedIn: 'root'
})
